import React, { useContext, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Col, Row, Button } from "react-bootstrap";
import { ProjectContext } from "../../ProjectContext";
import { FaEdit, FaPlus, FaTimes, FaRegTrashAlt } from "react-icons/fa";
import Moment from "react-moment";
import AssignWorkflowUsersFormModal from '../WorkflowUsers/AssignWorkflowUsersFormModal';
import DuplicateWorkflowFormModal from './DuplicateWorkflowFormModal';
import DeleteWorkflowFormModal from './DeleteWorkflowFormModal';
import { TbCopyPlus } from "react-icons/tb";
import { LuCopyPlus } from "react-icons/lu";
import API from "../../Utility/Api";


export default function WorkflowOverview({ children, workflow, setRefreshUsers, setRefreshTasks, ...routeProps }) {
  let { workflowId } = useParams();
  let history = useHistory();
  const { project } = useContext(ProjectContext);
  const [showAssignUsersFormModal, setShowAssignUsersFormModal] = useState();
  const [showDuplicateFormModal, setShowDuplicateFormModal] = useState();
  const [showDeleteFormModal, setShowDeleteFormModal] = useState();
  const [deleteMessageShow, setDeleteMessageShow] = useState(false);
  const [deleteMessageError, setDeleteMessageError] = useState(null);

  const getRoleName = (role) => {
    let roleIndex = workflow.assigneeRoles.findIndex((aRole) => aRole._id === role);
    if (roleIndex > -1) {
      return workflow.assigneeRoles[roleIndex].name;
    } else {
      return '';
    }
  };

  const onSuccessAssignUsersFormModal = () => {
    setShowAssignUsersFormModal(false);
    setRefreshUsers(true);
    setRefreshTasks(true);
  };

  const onSuccessDuplicateFormModal = () => {
    setShowDuplicateFormModal(false);
  };

  const onSuccessDeleteFormModal = () => {
    setShowDeleteFormModal(false);
  };

  const deleteWorkflow = async () => {
    setDeleteMessageShow(true);
    setDeleteMessageError(null);
    try {
      const response = await API.delete({
        url: `/admin/${project._id}/workflows/${workflowId}`
      });
      if (response.status === 200) {
        setDeleteMessageShow(false);
        setDeleteMessageError(null);
        history.push(`/workflows/${project._id}`);
      } else {
        const error = await response.json();
        setDeleteMessageShow(true);
        setDeleteMessageError(error);
      }
    } catch (error) {
      setDeleteMessageShow(true);
      setDeleteMessageError(error);
    }
  };

  return <div>
    <div className="workflow-overview">
      <Row style={{ width: '100%', margin: '0 10px' }}>
        <Col style={{ width: '100%', textAlign: 'right', float: 'right' }}>
          <div style={{ width: '100%', textAlign: 'right' }}>
            { (project?.userPermissions?.isWorkflowManager || project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) &&
            <>
              <Button
                style={{ marginRight: '10px', marginBottom: '10px' }}
                onClick={() => {
                  history.push({
                    pathname: `/workflows/${project?._id}/${workflowId}/update`,
                    state: { campaign: {} },
                  });
                }}
                variant="outline-primary"
              >
                <FaEdit style={{ verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}> Edit Workflow</span>
              </Button>
              {workflow?.status === 'Active' && (
                <Button
                  style={{ marginRight: '10px', marginBottom: '10px' }}
                  onClick={() => {
                    setShowAssignUsersFormModal(true);
                  }}
                  variant="outline-primary"
                >
                  <FaPlus style={{ verticalAlign: "middle" }}></FaPlus>
                  <span style={{ verticalAlign: "middle" }}> Assign User</span>
                </Button>
              )}
              <Button
                style={{ marginRight: '10px', marginBottom: '10px' }}
                onClick={() => {
                  setShowDuplicateFormModal(true);
                }}
                variant="outline-secondary"
              >
                {/* <img style={{ height: '25px' }} src="/Duplicate.svg" alt="Duplicate" /> */}
                <LuCopyPlus style={{ verticalAlign: "middle", transform: "scaleX(-1)" }}></LuCopyPlus>
                <span style={{ verticalAlign: "middle" }}> Duplicate Workflow</span>
              </Button>
              <Button
                style={{ marginRight: '10px', marginBottom: '10px' }}
                onClick={() => {
                  setShowDeleteFormModal(true);
                }}
                variant="outline-secondary"
              >
                <FaRegTrashAlt style={{ verticalAlign: "middle", marginTop: '-5px' }}></FaRegTrashAlt>
                <span style={{ verticalAlign: "middle" }}> Delete Workflow</span>
              </Button>
            </>
            }
          </div>
        </Col>
      </Row>
      <Row style={{ margin: '0 10px' }}>
        <Col>
          <Row>
            <Col><b>Status</b></Col>
          </Row>
          <Row>
            <Col>{workflow.status}</Col>
          </Row>
          <p></p>
          <Row>
            <Col><b>Description</b></Col>
          </Row>
          <Row>
            <Col>{workflow.description || 'N/A'}</Col>
          </Row>
          <p></p>
          <Row>
            <Col><b>Date Created</b></Col>
          </Row>
          <Row>
            <Col><Moment format="DD MMM 'YY">{workflow.created || workflow.milestones?.[0]?.created}</Moment></Col>
          </Row>
          <p></p>
          <Row>
            <Col><b>Roles</b></Col>
          </Row>
          <Row>
            <Col>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {workflow?.assigneeRoles?.length > 0 ? workflow.assigneeRoles.map((role) => {
                  return (
                    <span key={role._id} style={{ marginRight: '5px' }}>
                      {role.name}{workflow.assigneeRoles.indexOf(role) !== workflow.assigneeRoles.length - 1 ? ', ' : ''}
                    </span>
                  );
                }) : 'N/A'}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <p><br></br></p>
      {workflow?.milestones?.[0] && workflow?.milestones?.map((milestone, milestoneIndex) => {
        if (milestone.name) {
          return (
            <div key={`milestone-${milestoneIndex}`}>
              <Row style={{ width: '100%', margin: '0 auto' }}>
                <Col>
                  <Row style={{ backgroundColor: '#eee', padding: '20px 10px', borderRadius: '10px' }}>
                    <Col>
                      <b>{milestone.name}</b>
                    </Col>
                    <Col style={{ textAlign: 'right' }}>
                      <b>
                        <span>Day {milestone.startDay}</span>
                        {milestone.endDay !== milestone.startDay && (
                          <span>-{milestone.endDay}</span>
                        )}
                      </b>
                    </Col>
                  </Row>
                  <br></br>
                  <Row style={{ margin: '0 auto' }}>
                    <Col>
                      <Row style={{ padding: '0 0 20px 0', marginBottom: '20px', flexWrap: 'nowrap' }}>
                        <Col lg={2}><b>Task name</b></Col>
                        <Col lg={2}><b>Details</b></Col>
                        <Col lg={4}><b>Instructions</b></Col>
                        <Col lg={3}><b>Completion</b></Col>
                        {/* <Col><b>Assignees</b></Col> */}
                        <Col lg={1}><b>Duration</b></Col>
                      </Row>
                      {milestone?.tasks?.map((task, taskIndex) => {
                        return (
                          <Row key={`task-${milestoneIndex}-${taskIndex}`} style={{ borderBottom: taskIndex === milestone.tasks.length - 1 ? 'none' :  '1px solid #ccc', padding: '20px 0 20px 0', flexWrap: 'nowrap' }} className='task-row'>
                            <Col lg={2}>
                              <span style={{ fontWeight: '500' }}>{task.name}</span>
                            </Col>
                            <Col lg={2} style={{ textAlign: 'justify', paddingRight: '20px' }}>
                              <div dangerouslySetInnerHTML={{ __html: task.details }} />
                            </Col>
                            <Col lg={4} style={{ textAlign: 'justify', paddingRight: '20px' }}>
                              <div dangerouslySetInnerHTML={{ __html: task.instructions }} />
                            </Col>
                            {/* <Col>
                              <span>{task.userCanComplete ? 'User' : 'Assignee'}</span>
                            </Col> */}
                            <Col lg={3}>
                              {task.type === 'message' ? '' : (task.userCanComplete ? 'User' : task.assigneeRoles?.map((role, roleIndex) => {
                                if (roleIndex === 0) {
                                  return (
                                    <span key={roleIndex}>Assignee: {getRoleName(role)}</span>
                                  );
                                } else {
                                  return (
                                    <span key={roleIndex}>, {getRoleName(role)}</span>
                                  );
                                }
                              }))}
                            </Col>
                            <Col lg={1}>
                              {task.type === 'message' ? '' : (
                                <>
                                  <span>Day {task.startDay}</span>
                                  {task.endDay !== task.startDay && <span>-{task.endDay}</span>}
                                </>
                              )}

                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br></br>
            </div>
          );
        } else {
          return <div key={`milestone-${milestoneIndex}`}>
            <Row style={{ width: '100%', margin: '0 auto' }}>
              <Col>
                <Row style={{ backgroundColor: '#eee', padding: '20px 10px', borderRadius: '10px' }}>
                  <Col>
                    <b>No milestones added</b>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>;
        }
      })}
    </div>
    <AssignWorkflowUsersFormModal
      workflow={workflow}
      show={showAssignUsersFormModal}
      onCancel={() => {
        setShowAssignUsersFormModal(false);
      }}
      onSuccess={() => {
        onSuccessAssignUsersFormModal();
      }}
    />
    <DuplicateWorkflowFormModal
      workflow={workflow}
      show={showDuplicateFormModal}
      onCancel={() => {
        setShowDuplicateFormModal(false);
      }}
      onSuccess={() => {
        onSuccessDuplicateFormModal();
      }}
    />
    <DeleteWorkflowFormModal
      workflow={workflow}
      show={showDeleteFormModal}
      title={
        "Delete Workflow"
      }
      body={
        <>
          <p className={deleteMessageShow ? "hide" : ""}>
            {`This will delete the workflow and all associated data and can't be undone. Do you want to proceed?`}
          </p>
          <p className={deleteMessageShow ? "" : "hide"}>
            {deleteMessageError ? deleteMessageError?.message : 'Deleting workflow...'}
          </p>
        </>
      }
      confirmtext={"Delete"}
      onHide={(event, exitValue) => {
        if (exitValue) {
          deleteWorkflow();
        } else {
          setShowDeleteFormModal(false);
        }
      }}
      showspinner={(deleteMessageShow && deleteMessageError === null) ? 'show' : undefined}
    />
  </div>;
}